import { IListItem } from '../list-item';

export interface ISwapQualityIssue {
    id: number;
    chainId: number,
    clusterNumber: number,
    positionNumber: number,

    donorCenterId: number,
    donorCenter: string,
    rdnCenterId: number,
    rdnCenter: string,
    donorId: number,
    donorAlias: string,
    donorAge: number,
    donorFullBloodType: string,
    kidneyPickupDateTime: string,
    kidneyPickupDateTimeActual: string,
    kidneyArrivalDateTimeActual: string,
    transportMethodId: number,
    transportMethod: string,

    recipientCenterId: number,
    recipientCenter: string,
    recipientId: number,
    recipientAlias: string,
    recipientAge: number,
    recipientBloodType: string,
    recipientExportableDaysInNkr: number,

    recipientSwapQualityIssueTypes: number[];
    donorSwapQualityIssueTypes: number[];
    
    donorWhyWasKidneyLate: string;
    recipientIssueDescription: string;
    donorIssueDescription: string;
    recipientRootCause: string;
    donorRootCause: string;
    recipientCorrectiveAction: string;
    donorCorrectiveAction: string;
    
    recipientSurgeon: number;
    recipientSurgeonName: string;

    donorSurgeon: number;
    donorSurgeonName: string;

    recipientSurgicalAssistants: string;
    donorSurgicalAssistants: string;

    recipientDidSurgeonDiscussion: number;
    donorDidSurgeonDiscussion: number;
    
    recipientPreSurgicalDiscussionDetails: string;
    donorPreSurgicalDiscussionDetails: string;
    
    recipientPostSurgicalDiscussionDetails: string;
    donorPostSurgicalDiscussionDetails: string;

    administrativeNotes: string;

    recipientHaveOrganQualityConcerns: number;
    recipientDidOrganFunctionImmediately: number;
    recipientOrganQualityConcernDetails: string;
    recipientIsOrganCurrentlyFunctioning: number;
    recipientDoesPatientRequireReplacementKidney: number;

    requestInvestigation: number;
    reportedSwapQualityIssue: number;

    recipientKidneyPhoto1: string;
    recipientKidneyPhoto2: string;
    recipientKidneyPhoto3: string;

    donorKidneyPhoto1: string;
    donorKidneyPhoto2: string;
    donorKidneyPhoto3: string;

    recipientNoIssuesToReport: boolean;
    donorIssuesToReport: boolean;

    recipientIssuesFinalized: boolean;
    recipientIssuesFinalizedDateTime: string;
    recipientIssuesPendingDateTime: string;

    donorIssuesFinalized: boolean;
    donorIssuesFinalizedDateTime: string;
    donorIssuesPendingDateTime: string;

    replacementKidneyStatus: number;

    donorFinalizedBy: string;
    recipientFinalizedBy: string;

    nephrectomyDate: string;

    isLatePickup: boolean,
    isRecipientCenter: boolean
}